export const chartTypeOptions = [
  { value: 'line', label: 'Line' },
  { value: 'bar', label: 'Bar' },
]
